import { Result, backendApi } from "./backendApi";

export interface UpdateReportEntryModel {
  number?: string;
  type?: string;
  description?: string;
  hasCrsDataFileChanges: boolean;
  hasModelInfoChanges: boolean;
  regions: string[];
  hasModelInfo: boolean;
  isRsa: boolean;
  isNew: boolean;
  isCheckedOut: boolean;
}

class GetUpdateReportRequest {}

class GetUpdateReportResponse {
  reportEntries?: UpdateReportEntryModel[];
}

export const reportApi = {
  async getUpdateReport(): Promise<Result<UpdateReportEntryModel[]>> {
    const result =
      await backendApi.sendAndGetResponseAsync<GetUpdateReportResponse>(
        "GetUpdateReport",
        {} as GetUpdateReportRequest,
      );

    if (result.ok) {
      return {
        ok: true,
        value: result.value.reportEntries ?? [],
      };
    }

    return result;
  },
};
